import React from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineArrowLeft } from 'react-icons/hi2';

const RefundPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <div className="flex items-center">
            <Link 
              to="/" 
              className="flex items-center text-gray-600 hover:text-gray-900 transition-colors mr-6"
            >
              <HiOutlineArrowLeft className="w-5 h-5 mr-2" />
              Back to Home
            </Link>
            <h1 className="text-2xl font-bold text-gray-900 font-heading">
              Cancellation & Refund Policy
            </h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 lg:p-12">
          {/* Last Updated */}
          <div className="mb-8 pb-6 border-b border-gray-200">
            <p className="text-sm text-gray-500 font-sans">
              Last updated on Aug 17 2025
            </p>
          </div>

          {/* Introduction */}
          <div className="mb-8">
            <p className="text-gray-700 leading-relaxed font-sans">
              <strong>DEEPAK KUMAR</strong> believes in helping its customers as far as possible, and has therefore a liberal cancellation policy. Under this policy:
            </p>
          </div>

          {/* Policy Points */}
          <div className="space-y-6">
            <div className="flex items-start">
              <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
              <p className="text-gray-700 leading-relaxed font-sans">
                Cancellations will be considered only if the request is made within <strong>Not Applicable</strong> of placing the order. However, the cancellation request may not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them.
              </p>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
              <p className="text-gray-700 leading-relaxed font-sans">
                <strong>DEEPAK KUMAR</strong> does not accept cancellation requests for perishable items like flowers, eatables etc. However, refund/replacement can be made if the customer establishes that the quality of product delivered is not good.
              </p>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
              <p className="text-gray-700 leading-relaxed font-sans">
                In case of receipt of damaged or defective items please report the same to our Customer Service team. The request will, however, be entertained once the merchant has checked and determined the same at his own end. This should be reported within <strong>Not Applicable</strong> of receipt of the products.
              </p>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
              <p className="text-gray-700 leading-relaxed font-sans">
                In case you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within <strong>Not Applicable</strong> of receiving the product. The Customer Service Team after looking into your complaint will take an appropriate decision.
              </p>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
              <p className="text-gray-700 leading-relaxed font-sans">
                In case of complaints regarding products that come with a warranty from manufacturers, please refer the issue to them.
              </p>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-3 mr-4"></div>
              <p className="text-gray-700 leading-relaxed font-sans">
                In case of any Refunds approved by the <strong>DEEPAK KUMAR</strong>, it'll take <strong>Not Applicable</strong> for the refund to be processed to the end customer.
              </p>
            </div>
          </div>

          {/* Important Notice */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-yellow-800 mb-3 font-heading">
                Important Notice
              </h3>
              <p className="text-yellow-700 font-sans">
                Please note that some time periods in this policy are marked as "Not Applicable". For specific time frames and detailed information about cancellations and refunds, please contact our customer service team directly.
              </p>
            </div>
          </div>

          {/* Contact Information */}
          <div className="mt-8 pt-8 border-t border-gray-200">
            <h3 className="text-lg font-semibold text-gray-900 mb-4 font-heading">
              Contact Customer Service
            </h3>
            <div className="bg-gray-50 rounded-lg p-6">
              <p className="text-gray-700 font-sans">
                <strong>Company:</strong> DEEPAK KUMAR<br />
                <strong>Address:</strong> 104, Building No. - 15, Celebration KH4, Sector- 17, Kharghar Raigarh MH MAHARASHTRA 410210<br />
                <strong>Phone:</strong> 7900145175<br />
                <strong>Email:</strong> trendvectorofficial@gmail.com<br />
                <strong>For any queries regarding cancellations or refunds:</strong> Please contact us through our <Link to="/contact" className="text-blue-600 hover:text-blue-800 underline">Contact Us</Link> page.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPage;
